import * as React from "react";
import {ActionButton} from "components/Button";
import {ActionButtonType} from "components/Button/ActionButton";
import {SFC} from "react";
import {
    OpenDialogConnect,
    OpenDialogProps
} from "components/Dialog/OpenDialogConnect";
import {Permission} from "client/resources";
import PermissionCheck, { isAllowed, PermissionCheckProps } from "../PermissionCheck/PermissionCheck";
import Dialog from "components/Dialog/Dialog";
import dialogIdGenerator from "components/Dialog/dialogIdGenerator";
import styles = require("./style.less");

interface OpenDialogButtonProps {
    label: any;
    disabled?: boolean | Promise<any>;
    permission?: PermissionCheckProps;
    icon?: JSX.Element;
    type?: ActionButtonType;
    wideDialog?: boolean;
}

class OpenDialogButtonInternal extends React.Component<OpenDialogButtonProps & OpenDialogProps, never> {
    private uniqueId: string;

    constructor(props: OpenDialogButtonProps & OpenDialogProps) {
        super(props);

        this.uniqueId = dialogIdGenerator.next();
    }

    render() {
        const isOpen = this.props.openDialogs[this.uniqueId];
        const disabledDueToPermission = !!this.props.permission ? !isAllowed(this.props.permission) : false;

        return <div className={styles.buttonDialogContainer}>
            <ActionButton
                type={this.props.type}
                icon={this.props.icon}
                label={this.props.label}
                disabled={disabledDueToPermission || this.props.disabled}
                onClick={() => this.props.openDialog(this.uniqueId)}
            />
            <Dialog open={isOpen} wide={this.props.wideDialog}>
                {this.props.children}
            </Dialog>
        </div>;
    }
}

const OpenDialogButton = OpenDialogConnect.to<OpenDialogButtonProps>(OpenDialogButtonInternal);
export default OpenDialogButton;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/components/Dialog/OpenDialogButton.tsx